import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs/modular/sortable.core.esm.js';

// Connects to data-controller="sortable"
export default class extends Controller {
  connect() {
    Sortable.create(this.element);
  }
}
